import { LARAVEL_ENDPOINT } from './env'

export const FULL_ACCESS = [
  'tyson@vestaboard.com',
  'mark@vestaboard.com',
  'john@vestaboard.com',
  'alex@vestaboard.com',
  'james@vestaboard.com'
]
export const SUBSCRIPTION_EDITORS = [
  ...FULL_ACCESS,
  'aaron@vestaboard.com',
  'chakhala@vestaboard.com',
  'tito@vestaboard.com'
]
export const REPORTS_API = 'https://reports.vestaboard.com/api'
export const drawerWidth = 240
export const SITE_TITLE = 'Vestaboard Superadmin'
export const INSTALLABLES_MONOREPO_API = LARAVEL_ENDPOINT

/** Cadence configuration URL domains where leaving cadence token blank is recommended for service JWT auth. */
export const CADENCE_DOMAINS_SUPPORTING_SERVICE_JWT = [LARAVEL_ENDPOINT?.replace(/^https?:/, '')]
/** Origin of the insights REST app (`apps/insights`), no trailing slash. */
export { API_BASE_URL as PLATFORM_API, INSIGHTS_BASE_URL as INSIGHTS_API_BASE_URL } from './env'
